<template>
  <div class="vip-page bg">
    <top-header></top-header>
    <div v-if="showRightsCenter && !tempShowVipRuleByRightsOn" class="content">
      <!-- getSpecifyLang:目前只有日本大掌柜上线，所以默认日语，之后其他游戏上线后填充语言包后将该函数去除  -->
      <div class="content-box" style="overflow: hidden">
        <span class="back j-click-vip-back" @click="backToHome">
          < {{ letter.backToPay || getSpecifyLang('ja-JP', 'backToPay') }}
        </span>
        <!-- <div
          class="rule-content"
          style="margin-top: 100px; margin-bottom: 20px"
          v-if="+$store.state.gameId !== 213"
        >
          <p
            class="vip-info"
            v-html="
              letter.rightsIntro || getSpecifyLang('ja-JP', 'rightsIntro')
            "
          ></p>
        </div> -->
        <div
          style="
            width: 100%;
            padding: 40px 30px;
            margin-top: 100px;
            margin-bottom: 20px;
          "
        ></div>
        <div
          class="couponBtn j-click-vip-go-benefit-center"
          @click="jumpRights"
        >
          {{ letter.goToRights || getSpecifyLang('ja-JP', 'goToRights') }}
        </div>
        <p
          v-if="+$store.state.gameId !== 213"
          class="vip-info"
          style="margin-top: 200px; padding: 0 40px; text-align: left"
        >
          {{ letter.oldVipIntro || getSpecifyLang('ja-JP', 'oldVipIntro') }}
        </p>
        <p v-else style="margin-top: 40px"></p>
        <div
          class="ratioBtn j-click-vip-my-coupon"
          @click="showGameCouponPopup"
        >
          {{ letter.couponMyQuan || getSpecifyLang('ja-JP', 'couponMyQuan') }}
        </div>
      </div>
    </div>
    <div v-else class="content">
      <div class="content-box">
        <span
          class="back j-click-vip-back"
          @click="backToHome"
          v-if="showBackToPay"
        >
          < {{ letter.backToPay }}
        </span>
        <p class="pay-title">{{ letter.vipTitle }}</p>
        <div class="vip-info">
          <p>
            {{ letter.nowLevel
            }}<span class="vip-level"> VIP {{ vipLevel }}</span>
          </p>
          <p>
            {{ letter.myVipScore
            }}<span class="vip-sum">{{
              this.isUidLogin ? '***' : vipSumPoint
            }}</span>
          </p>
          <p v-if="+vipNextLevelPoint !== 0">
            {{ nextLevelNeed }}
          </p>
        </div>
        <div
          class="couponBtn j-click-vip-my-coupon"
          @click="showGameCouponPopup"
        >
          {{ letter.couponMyQuan }}
        </div>
        <div class="rule-content">
          <template v-if="showRightCenterPopup">
            <p style="text-align: center">
              {{
                +$store.state.gameId === 191
                  ? letter.rightCenterNoticeTitle
                  : letter.notice
              }}
            </p>
            <p v-html="rightsIntro"></p>
          </template>
          <template
            v-else-if="showVipScoreDownIntro && vipScoreDownIntroLang.show"
          >
            <p
              v-html="vipScoreDownIntroLang.popupTitle"
              style="white-space: pre-line"
            ></p>
            <p
              v-html="vipScoreDownIntroLang.popupContent"
              style="white-space: pre-line"
            ></p>
          </template>
          <template v-else>
            <p
              class="part-1 text"
              v-for="(item, index) in ruleConfig.ruleNum"
              :key="index"
            >
              {{
                letter[gamePrefix + 'VipRule' + item].replaceAll(
                  '${gameName}',
                  gameName
                )
              }}
            </p>
          </template>
          <table class="vip-desc-table" aria-describedby="vipPointDesc">
            <tr>
              <th>{{ letter.vipLevel }}</th>
              <th>{{ letter.vipCondition }}</th>
              <th>{{ letter.firstSend }}</th>
              <th>{{ letter.weeklySend }}</th>
            </tr>
            <tbody>
              <tr v-for="(item, index) in tableList" :key="index">
                <td>VIP {{ index + 1 }}</td>
                <td>{{ item[0] }}</td>
                <td>{{ item[1] }}</td>
                <td>{{ item[2] }}</td>
              </tr>
            </tbody>
          </table>
          <p class="part3 text"></p>
          <p
            style="text-align: center"
            v-if="showRightCenterPopup"
            class="rightCenterTableTitle"
          >
            {{ letter.rightCenterNoticeTableTitle }}
          </p>
          <table
            v-if="showRightCenterPopup"
            class="right-center-table"
            aria-describedby="rightCenterDesc"
          >
            <tr>
              <th>{{ letter.rightCenterNoticeTableHeader1 }}</th>
              <th>{{ letter.rightCenterNoticeTableHeader2 }}</th>
              <th>{{ letter.rightCenterNoticeTableHeader3 }}</th>
              <th>{{ letter.rightCenterNoticeTableHeader4 }}</th>
              <th>{{ letter.rightCenterNoticeTableHeader5 }}</th>
            </tr>
            <tbody>
              <tr>
                <td>{{ letter.rightCenterNoticeTableLevel1 }}</td>
                <td>VIP1</td>
                <td>5%</td>
                <td>{{ letter.rightCenterNoticeTableCount1 }}</td>
                <td rowspan="5">{{ letter.rightCenterNoticeTableLimit }}</td>
              </tr>
              <tr>
                <td>{{ letter.rightCenterNoticeTableLevel2 }}</td>
                <td>VIP2</td>
                <td>7%</td>
                <td>{{ letter.rightCenterNoticeTableCount2 }}</td>
              </tr>
              <tr>
                <td>{{ letter.rightCenterNoticeTableLevel3 }}</td>
                <td>VIP3</td>
                <td>9%</td>
                <td>{{ letter.rightCenterNoticeTableCount2 }}</td>
              </tr>
              <tr>
                <td>{{ letter.rightCenterNoticeTableLevel4 }}</td>
                <td>VIP4</td>
                <td>11%</td>
                <td>{{ letter.rightCenterNoticeTableCount3 }}</td>
              </tr>
              <tr>
                <td>{{ letter.rightCenterNoticeTableLevel5 }}</td>
                <td>VIP5</td>
                <td>13%</td>
                <td>{{ letter.rightCenterNoticeTableCount3 }}</td>
              </tr>
            </tbody>
          </table>
          <p v-if="showVipScoreDownIntro && vipScoreDownIntroLang.show">
            {{ vipScoreDownIntroLang.headerTip }}
          </p>
          <table
            style="text-align: center"
            v-if="showVipScoreDownIntro && vipScoreDownIntroLang.show"
            class="contrast-center-table"
          >
            <tr>
              <th
                v-for="(item, index) in vipScoreDownIntroLang.tableHeaderTip"
                :key="index"
              >
                {{ item }}
              </th>
            </tr>
            <tbody>
              <tr
                v-for="(item, index) in vipScoreDownIntroLang.tableBodyTip"
                :key="index"
              >
                <td>{{ item[0] }}</td>
                <td>{{ item[1] }}</td>
                <td>{{ item[2] }}</td>
                <td>{{ item[3] }}</td>
                <td v-if="index === 0" rowspan="5">{{ item[4] }}</td>
              </tr>
            </tbody>
          </table>
          <p
            style="margin-bottom: 20px"
            v-if="showVipScoreDownIntro && vipScoreDownIntroLang.show"
          >
            {{ vipScoreDownIntroLang.footerTip }}
          </p>
          <p
            style="margin-bottom: 20px"
            v-if="showRightCenterPopup"
            class="rightCenterTableTip"
          >
            {{ letter.rightCenterNoticeTableTip }}
          </p>
          <div
            class="ratioBtn j-click-vip-ratio"
            v-if="visibleCouponRatio"
            @click="jumpLink"
          >
            {{ letter.couponRatio }}
          </div>
          <div
            v-if="tempShowVipRuleByRightsOn"
            class="couponBtn j-click-vip-go-benefit-center"
            @click="jumpRights"
          >
            {{ letter.goToRights || getSpecifyLang('ja-JP', 'goToRights') }}
          </div>
          <div
            class="ratioBtn j-click-vip-coupon-limit-ratio"
            v-if="couponTopLimitLink"
            @click="jumpCouponTopLimitLink"
          >
            {{ letter.couponTopLimit }}
          </div>
        </div>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :activeId="gameActiveCouponId"
        :showItemUseBtn="isShowGameItemUseBtn"
        @closeCouponPopup="hideGameCouponPopup"
      ></coupon-list-popup>
    </transition>
    <theme-config v-if="showThemeConfig"></theme-config>
  </div>
</template>

<script>
import TopHeader from '@components/officialStore/TopHeader.vue';
import CouponListPopup from '@components/officialStore/coupon/CouponListPopup.vue';
import coupon from '@mixins/officialStore/coupon';
import { clickButton } from '@plugins/biPoint/_configWebstoreV1';
import globalConfig from '@utiles/officialStore/globalConfig';
import languages from '@store/languages/index';
import { mapGetters } from 'vuex';
import openActivity, { VIP_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  name: 'VipPage',
  mixins: [coupon],
  created() {
    this.loadGameCouponList();
    this.loadVipCouponInfo();
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    isUidLogin() {
      return this.$store.state.login.isUidLogin;
    },
    gamePrefix() {
      if (+this.$store.state.gameId === 213) {
        // 因为默认的多语言都是一致的按gameCode分辨，本次修改中韩国dzg与全球dzg的gameCode一致，但是全球大掌柜文案要独立一套，因此先按gameId作区分
        return (
          this.$store.state.gameId + this.$store.getters.gameInfoConfig.gameCode
        );
      }
      return this.$store.getters.gameInfoConfig.gameCode;
    },
    ruleConfig() {
      return this.$store.getters.gameInfoConfig.vipRuleConfig;
    },
    rightsCenterLink() {
      return this.$store.getters.gameInfoConfig.rightsCenterLink;
    },
    tempShowVipRuleByRightsOn() {
      const tempShowVipRuleByRightsOnEndDate =
        this.$store.getters.gameInfoConfig?.tempShowVipRuleByRightsOnEndDate;
      if (tempShowVipRuleByRightsOnEndDate) {
        return new Date(tempShowVipRuleByRightsOnEndDate) > new Date();
      }
      return false;
    },
    showThemeConfig() {
      return this.$store.state.showThemeConfig;
    },
    gameName() {
      return this.ruleConfig.gameName;
    },
    nextLevelNeed() {
      return this.letter.nextLevelNeed
        .replace(
          '${num}',
          this.isUidLogin ? '***' : this.vipNextLevelPoint - this.vipSumPoint
        )
        .replace('${level}', this.isUidLogin ? '***' : +this.vipLevel + 1);
    },
    tableList() {
      if (!this.ruleConfig.table) {
        return [];
      }
      const reg = /\$\{(.+?)\}/;
      const reg_g = /\$\{(.+?)\}/g;
      return this.ruleConfig.table.map(item => {
        let itemToStr = item.join('---');
        let matchArr = itemToStr.match(reg_g);
        matchArr.forEach(target => {
          itemToStr = itemToStr.replaceAll(
            target.toString(),
            this.letter[target.match(reg)[1]]
          );
        });
        return itemToStr.split('---');
      });
    },
    couponTopLimitLink() {
      return this.ruleConfig.couponTopLimitLink;
    },
    visibleCouponRatio() {
      // 日本平台不展示VIP积分比例跳转按钮
      return !this.$store.getters.isJpPlatform;
    },
    rightsIntro() {
      if (+this.$store.state.gameId === 191) {
        return this.letter.rightCenterNoticeContent;
      }
      return (
        this.letter.preRightsIntro.replace(
          '${offLineDate}',
          this.gameInfoConfig?.offLineDate[this.lang] ||
            this.gameInfoConfig?.offLineDate['en-US'] ||
            ''
        ) || ''
      );
    },
    showBackToPay() {
      return !this.isV3;
    },
    isV3() {
      return globalConfig?.getHrefParam('fromV3') == 1;
    },
    showVipScoreDownIntro() {
      return this.gameInfoConfig?.vipScoreDownIntro?.isShow;
    },
    vipScoreDownIntroLang() {
      return (
        this.gameInfoConfig?.vipScoreDownIntro?.langMap?.[this.lang] ||
        this.gameInfoConfig?.vipScoreDownIntro?.langMap?.['en-US'] ||
        {}
      );
    },
    ...mapGetters([
      'gameInfoConfig',
      'showRightsCenter',
      'showRightCenterPopup'
    ])
  },
  methods: {
    backToHome() {
      clickButton({
        btnName: 'back_homePage',
        locationKey: this.$route.meta.pageName
      });
      this.$router.push({
        name: 'home'
      });
    },
    jumpLink() {
      window.open(this.ruleConfig.link, '_blank');
    },
    jumpCouponTopLimitLink() {
      window.open(this.couponTopLimitLink, '_blank');
    },
    jumpRights() {
      openActivity(VIP_ACTIVITY, this.rightsCenterLink, {
        language: this.lang,
        appLanguage: this.lang,
        ...getGlobalGetLinkParams()
      });
    },
    getSpecifyLang(lang, key) {
      return languages.getSpecifyLang(lang, key);
    }
  },
  components: {
    TopHeader,
    CouponListPopup,
    ThemeConfig: () => import('@components/officialStore/ThemeConfig.vue')
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';

.bg {
  display: block;
  float: left;
  position: relative;
  width: 100%;
  height: auto;
  min-height: 100%;
  background-color: var(--vip-bg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  text-align: center;
  // @psetbg ('bg.png', false,false);
}

.content {
  position: relative;
  margin: 150px 0 200px;
}

.vip-info {
  margin-bottom: 20px;
  line-height: 40px;
  font-size: 25px;
  color: var(--vip-info);

  p {
    text-align: center;
  }

  .vip-level {
    font-size: 30px;
    color: var(--vip-level-highlight);
  }
}

.content-box {
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 1px 30px;
  max-width: 1200px;
  font-size: 0;
  color: var(--vip-content);

  .back {
    position: absolute;
    left: 20px;
    height: 30px;
    cursor: pointer;
    font-size: 30px;
  }

  .pay-title {
    margin: 80px 0 20px;
    text-align: center;
    font-weight: 600;
    font-size: 60px;
    color: var(--vip-title);
  }

  .couponBtn,
  .ratioBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    background-size: 100% 100%;
    cursor: pointer;
    font-size: 30px;
    color: var(--vip-btn-text-color);
  }

  .couponBtn {
    cursor: pointer;
    @psetbg ('vip-coupon-btn-bg.png', false);
  }

  .ratioBtn {
    cursor: pointer;
    margin-bottom: 20px;
    @psetbg ('vip-coupon-ratio.png', false);
  }

  .rule-content {
    box-sizing: border-box;
    margin-top: 30px;
    padding: 40px 30px;
    background-color: var(--vip-rule-bg);
    color: var(--vip-info);

    p {
      line-height: 40px;
      text-align: left;
      font-size: 22px;
    }

    .mt {
      margin-top: 50px;
    }
  }

  .vip-desc-table,
  .right-center-table,
  .contrast-center-table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 10px * 2 auto 30px;
    width: 96%;

    th,
    td {
      border: 1px solid var(--vip-table-border);
      height: 61px;
      line-height: 25px;
      text-align: center;
      font-size: 20px;
      color: var(--vip-table-text);
      white-space: pre-wrap;
    }
  }

  .contrast-center-table {
    th,
    td {
      white-space: normal;
    }
  }
}

@media screen and (orientation: landscape) {
  // .bg {
  // background-repeat: repeat-y;
  // background-size: auto;
  // @psetbg ('bg-hen.png', false,false);
  // }
}
</style>
